import { NavLink } from "react-router-dom";
import styled from "styled-components";

const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  row-gap: 15px;
  padding: 0 10px;

  font-family: "Josefin Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0.2em;
  margin-top: 30px;
  text-align: center;
`;

const StyledNavLink = styled(NavLink)`
  font-weight: light;
  text-decoration: none;
  color: #4a4a4a;

  &[aria-current] {
    font-weight: bold;
  }
`;

const BuyNowLink = styled(NavLink)`
  font-weight: bold;
  text-decoration: none;
  color: rgb(169, 46, 153);
`;

export default function TopNav() {
  return (
    <LinksContainer>
      <StyledNavLink to="/">OVERVIEW</StyledNavLink>
      <StyledNavLink to="/game">THE GAME</StyledNavLink>
      <StyledNavLink to="/resources">RESOURCES</StyledNavLink>
      <StyledNavLink to="/presskit">PRESS KIT</StyledNavLink>
      <BuyNowLink to="/buy">BUY NOW</BuyNowLink>
    </LinksContainer>
  );
}
